import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Viewer from 'v-viewer'

Vue.config.productionTip = false

Vue.use(Viewer, {
    defaultOptions: {
        movable: false,
        rotatable: false,
        scalable: false,
        tooltip: false,
        title: false,
        zoomable: false
    }
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#vue-container-profile-classes-metrics')
